import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterOutlet, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs';
import { Header } from './components/header/header';
import { Footer } from './components/footer/footer';


@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet, Header, Footer],
  templateUrl: './app.html',
  styleUrl: './app.css',
})
export class App {
  private router = inject(Router);

  mostrarLayoutSite = true;

  constructor() {
    this.atualizarLayout(this.router.url);

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.atualizarLayout(event.urlAfterRedirects);
      });
  }

  private atualizarLayout(url: string): void {
    const rota = url.split('?')[0].split('#')[0];

    this.mostrarLayoutSite = !(
      rota === '/login' ||
      rota === '/primeiro-acesso' ||
      rota === '/admin' ||
      rota.startsWith('/admin/') ||
      rota === '/parceiro' ||
      rota.startsWith('/parceiro/')
    );
  }
}
